import { datadogRum } from '@datadog/browser-rum'

export default function (context, inject) {
  console.info('[Datadog] Starting RUM', process.env.DD_CLIENT_APPLICATION_ID)
  console.info('[Datadog] Environment', process.env.DEV_ENV)
  datadogRum.init({
    applicationId: process.env.DD_CLIENT_APPLICATION_ID,
    clientToken: process.env.DD_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'web.landing',
    // TODO: Use a proper versioning strategy
    // This version should match the one used when uploading sourcemaps in the CI/CD pipeline
    version: process.env.CIRCLE_SHA1,
    sampleRate: 100,
    trackInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
    env: process.env.DEV_ENV,
  })

  datadogRum.startSessionReplayRecording()

  inject('datadog', datadogRum)

  console.log('[Datadog] RUM Started!', process.env.DD_CLIENT_APPLICATION_ID)
}
